import AdminInformationEdit from "~/pages/admin/Information/AdminInformationEdit.vue";
import AdminInformationList from "~/pages/admin/Information/AdminInformationList.vue";
import TopPage from "~/pages/top/TopPage.vue";
import InformationDetail from "~/pages/information/InformationDetail.vue";
import InformationList from "~/pages/information/InformationList.vue";
import KeiyakushaList from "~/pages/admin/Keiyakusha/KeiyakushaList.vue";
import AccountDetail from "~/pages/admin/Keiyakusha/AccountDetail.vue";
import AdminPasswordChangePage from "~/pages/admin/password/AdminPasswordChangePage.vue";
/**支店ユーザ用ルート */
const branchRoutes = [
    //トップページ
    { name: "top", path: "top", component: TopPage },
    //お知らせ
    { name: "admin-information-list", path: "admin-information-list", component: AdminInformationList, meta: { adminOnly: true } },
    { name: "information-list", path: "information-list", component: InformationList },
    { name: "information-edit", path: "information-edit", component: AdminInformationEdit, meta: { adminOnly: true } },
    { name: "information-detail", path: "information-detail", component: InformationDetail },
    // 契約者一覧、アカウント編集
    { name: "keiyakusha-list", path: "keiyakusha-list", component: KeiyakushaList, meta: { adminOnly: true } },
    { name: "account-edit", path: "account-edit", component: AccountDetail, meta: { adminOnly: true } },
    // パスワード変更
    { name: "admin-password-change", path: "admin-password-change", component: AdminPasswordChangePage, meta: { adminOnly: true } }
];
export default branchRoutes;
